<div class="container-fluid">
  <div class="row">
    <div class="col-md-12">
      <div class="breadcrumb-title border-0 mb-3 mt-md-0 mt-4">
        <app-list-header
          [title]="'Development Apps' | translate"
          icon="bi bi-person-workspace"
          [$parent]="getSelf()"
        >
        </app-list-header>
      </div>
    </div>
    <div class="col-md-12 mt-3">
      <div class="card">
        <div class="card-body">
          <div class="row">
            <div class="col-md-12 mb-2">
              <button
                mat-stroked-button
                color="primary"
                (click)="toggleSearch()"
                matTooltip="{{ 'APP_STORE.SEARCH.FILTER' | translate }}"
                matTooltipPosition="above"
              >
                <mat-icon>tune</mat-icon>
                <span>{{ "APP_STORE.SEARCH.FILTER" | translate }}</span>
              </button>
            </div>
            <div class="col-md-12 mb-2">
              <form
                class="row align-items-center compact-inputs"
                *ngIf="isExpanded"
              >
                <div class="col-xxl-3 col-xl-4 col-md-6 col-sm-6 col-12 mb-2">
                  <div class="d-flex justify-content-start align-items-center">
                    <div class="flex-grow-1 dropdown-pd-none">
                      <mat-form-field appearance="outline" class="w-100">
                        <mat-label>{{
                          "Collaborators.FORM.APPLICATION" | translate
                        }}</mat-label>
                        <mat-select
                          [(ngModel)]="form.searchParams['applicationName']"
                          [ngClass]="{
                            'placeholder-grey':
                              form.searchParams['applicationName'] ===
                              undefined,
                          }"
                          id="applicationName"
                          name="applicationName"
                        >
                          <mat-option value="undefined" disabled>
                            {{
                              "UsecaseData.USECASE.LIST.SELECT_PLACEHOLDER"
                                | translate
                                  : {
                                      field:
                                        ("Collaborators.FORM.APPLICATION"
                                        | translate),
                                    }
                            }}
                          </mat-option>
                          <mat-option
                            *ngFor="let e1 of getUniqueApplicationNames()"
                            [value]="e1.applicationName"
                          >
                            {{ e1.applicationName | truncate }}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>
                    </div>
                    <button
                      mat-icon-button
                      matTooltip="{{
                        'ALLREMAININGS.Search_by_name' | translate
                      }}"
                      matTooltipPosition="above"
                      class="icon-center icon-clean"
                      aria-label="Application Name"
                    >
                      <mat-icon class="text-secondary icon-compact"
                        >info</mat-icon
                      >
                    </button>
                  </div>
                </div>
                <div class="col-xxl-3 col-xl-4 col-md-6 col-sm-6 col-12 mb-2">
                  <div class="d-flex justify-content-start align-items-center">
                    <div class="flex-grow-1 dropdown-pd-none">
                      <mat-form-field appearance="outline" class="w-100">
                        <mat-label>{{
                          "PIVOT.PLACEHOLDERS.ENTER_VALUE" | translate
                        }}</mat-label>
                        <input
                          matInput
                          [(ngModel)]="form.searchParams['senderName']"
                          id="senderName"
                          name="senderName"
                        />
                      </mat-form-field>
                    </div>
                    <button
                      mat-icon-button
                      matTooltip="{{
                        'ALLREMAININGS.Search_by_sender_name' | translate
                      }}"
                      matTooltipPosition="above"
                      class="icon-center icon-clean"
                      aria-label="Sender Name"
                    >
                      <mat-icon class="text-secondary icon-compact"
                        >info</mat-icon
                      >
                    </button>
                  </div>
                </div>
                <div class="col-xxl-3 col-xl-4 col-md-6 col-sm-6 col-12 mb-2">
                  <div class="d-flex justify-content-start align-items-center">
                    <div class="flex-grow-1 dropdown-pd-none">
                      <mat-form-field appearance="outline" class="w-100">
                        <mat-label>{{
                          "Collaborators.SELECT.STATUS" | translate
                        }}</mat-label>
                        <mat-select
                          [(ngModel)]="form.searchParams['status']"
                          [ngClass]="{
                            'placeholder-grey':
                              form.searchParams['status'] === undefined,
                          }"
                          id="status"
                          name="status"
                        >
                          <mat-option value="undefined" disabled>
                            {{ "Collaborators.SELECT.STATUS" | translate }}
                          </mat-option>
                          <mat-option value="Accept">{{
                            "Collaborators.STATUS.ACCEPT" | translate
                          }}</mat-option>
                          <mat-option value="Reject">{{
                            "Collaborators.STATUS.REJECT" | translate
                          }}</mat-option>
                          <mat-option value="Pending">{{
                            "Collaborators.STATUS.PENDING" | translate
                          }}</mat-option>
                          <mat-option value="Blocked">{{
                            "Collaborators.STATUS.BLOCKED" | translate
                          }}</mat-option>
                        </mat-select>
                      </mat-form-field>
                    </div>
                    <button
                      mat-icon-button
                      matTooltip="{{
                        'ALLREMAININGS.Filter_by_status' | translate
                      }}"
                      matTooltipPosition="above"
                      class="icon-center icon-clean"
                      aria-label="Status"
                    >
                      <mat-icon class="text-secondary icon-compact"
                        >info</mat-icon
                      >
                    </button>
                  </div>
                </div>
                <div class="col-auto pe-1">
                  <button
                    mat-stroked-button
                    color="primary"
                    (click)="search()"
                    class="btn-sm"
                  >
                    <mat-icon>search</mat-icon>
                    {{ "UsecaseData.USECASE.LIST.ACTIONS.SEARCH" | translate }}
                  </button>
                </div>
                <div class="col-auto ps-1">
                  <button
                    mat-stroked-button
                    color="primary"
                    (click)="resetSearchForm()"
                    color="warn"
                    id="marginSet"
                  >
                    <i class="fa fa-eraser eraser-warn-dark"></i>
                    <span class="ms-2">{{
                      "UsecaseData.USECASE.LIST.ACTIONS.RESET" | translate
                    }}</span>
                  </button>
                </div>
              </form>
              <div class="mt-3">
                <p
                  *ngIf="form['searchError'] == false && form['searchMessage']"
                >
                  <app-ncs-alert
                    [message]="form['searchMessage']"
                    type="success"
                  />
                </p>
                <p *ngIf="form['searchError'] == true && form['searchMessage']">
                  <app-ncs-alert
                    [message]="form['searchMessage']"
                    type="danger"
                  />
                </p>
                <p *ngIf="form['error'] == false && form['message']">
                  <app-ncs-alert [message]="form['message']" type="success" />
                </p>
                <p *ngIf="form['error'] == true && form['message']">
                  <app-ncs-alert [message]="form['message']" type="danger" />
                </p>
              </div>
            </div>
            <div class="col-md-12 mb-3">
              <div class="table-container">
                <div class="table-responsive table-scrollable">
                  <table class="table table-bordered table-sticky-header">
                    <thead>
                      <tr>
                        <th class="text-center">
                          {{ "Collaborators.TABLE.S_NO" | translate }}
                        </th>
                        <th>
                          {{ "Collaborators.FORM.APPLICATION" | translate }}
                          {{ "Collaborators.FORM.NAME" | translate }}
                        </th>
                        <th>{{ "Collaborators.FORM.SENDER" | translate }}</th>
                        <th>{{ "Collaborators.TABLE.STATUS" | translate }}</th>
                        <th>{{ "COMMON.ACTIONS" | translate }}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let e of form.list; let i = index">
                        <td class="text-center">{{ pageIndex(i) }}</td>
                        <td>
                          <span
                            class="nav-link"
                            matTooltip="{{ e.applicationName }}"
                            matTooltipPosition="above"
                          >
                            {{ e.applicationName | truncate }}
                          </span>
                        </td>
                        <td>
                          <span>{{ e.senderName }}</span>
                          <span class="ms-1"
                            ><b>({{ e.role }})</b></span
                          >
                        </td>

                        <!-- Status Column -->
                        <td *ngIf="e.status === 'Blocked'">
                          {{ "Collaborators.STATUS.BLOCKED" | translate }}
                        </td>
                        <td
                          *ngIf="e.status !== 'Blocked'"
                          class="compact-inputs"
                        >
                          <mat-form-field
                            appearance="outline"
                            class="dropdown-pd-none"
                          >
                            <mat-select
                              [(ngModel)]="e.status"
                              (selectionChange)="changeStatus(e.id, e.status)"
                              id="status"
                              name="status"
                            >
                              <mat-option value="" disabled>
                                {{ "PIVOT.SELECT.DEFAULT_SELECT" | translate }}
                              </mat-option>
                              <mat-option value="Pending">
                                {{ "Collaborators.STATUS.PENDING" | translate }}
                              </mat-option>
                              <mat-option value="Accept">
                                {{ "Collaborators.STATUS.ACCEPT" | translate }}
                              </mat-option>
                              <mat-option value="Reject">
                                {{ "Collaborators.STATUS.REJECT" | translate }}
                              </mat-option>
                            </mat-select>
                          </mat-form-field>
                        </td>
                        <td>
                          <div class="d-flex">
                            <!-- API Button -->
                            <button
                              mat-stroked-button
                              color="primary"
                              [disabled]="e.status !== 'Accept'"
                              matTooltip="{{
                                'Collaborators.BUTTONS.API' | translate
                              }}"
                              class="icon-center icon-clean icon-width me-2"
                              matTooltipPosition="above"
                              (click)="goto(e.applicationId)"
                            >
                              <i class="bx bx-network-chart"></i>
                              <small class="ms-2">{{
                                "Collaborators.BUTTONS.API" | translate
                              }}</small>
                            </button>

                            <!-- Role Button -->
                            <button
                              mat-stroked-button
                              color="primary"
                              [disabled]="e.status !== 'Accept'"
                              class="me-2"
                              matTooltip="{{
                                'Collaborators.TABLE.ROLE' | translate
                              }}"
                              matTooltipPosition="above"
                              data-bs-toggle="modal"
                              data-bs-target="#appRoleModal"
                              (click)="setApp(e, 'app-role')"
                            >
                              <mat-icon>group</mat-icon>
                              <small>{{
                                "Collaborators.TABLE.ROLE" | translate
                              }}</small>
                            </button>

                            <!-- Role Usecase Button -->
                            <button
                              mat-stroked-button
                              color="primary"
                              [disabled]="e.status !== 'Accept'"
                              class="me-2"
                              matTooltip="{{
                                'Collaborators.BUTTONS.ACCESS' | translate
                              }}"
                              matTooltipPosition="above"
                              data-bs-toggle="modal"
                              data-bs-target="#appRoleUsecaseModal"
                              (click)="setApp(e, 'app-role-usecase')"
                            >
                              <mat-icon>lock</mat-icon>
                              <small>{{
                                "Collaborators.BUTTONS.ACCESS" | translate
                              }}</small>
                            </button>

                            <!-- Menu Button -->
                            <button
                              mat-stroked-button
                              color="primary"
                              [disabled]="e.status !== 'Accept'"
                              class="me-2"
                              matTooltip="{{
                                'Collaborators.BUTTONS.MENU' | translate
                              }}"
                              matTooltipPosition="above"
                              [routerLink]="['/menus/' + e.id]"
                              (click)="setApp(e, 'app-menus')"
                            >
                              <mat-icon>menu_open</mat-icon>
                              <small>{{
                                "Collaborators.BUTTONS.MENU" | translate
                              }}</small>
                            </button>

                            <!-- App Users Button -->
                            <button
                              mat-stroked-button
                              color="primary"
                              [disabled]="e.status !== 'Accept'"
                              class="me-2"
                              matTooltip="{{
                                'Collaborators.BUTTONS.USERS' | translate
                              }}"
                              matTooltipPosition="above"
                              data-bs-toggle="modal"
                              data-bs-target="#appUserModal"
                              (click)="setApp(e, 'app-user')"
                            >
                              <mat-icon>group_add</mat-icon>
                              <small>{{
                                "Collaborators.BUTTONS.USERS" | translate
                              }}</small>
                            </button>

                            <button
                              mat-stroked-button
                              color="primary"
                              class="btn-sm me-2 mb-1 action-button dropdown-button"
                              [matMenuTriggerFor]="settingsMenu"
                              matTooltip="{{
                                'Collaborators.BUTTONS.SETTINGS' | translate
                              }}"
                              matTooltipPosition="above"
                            >
                              <div class="d-flex align-items-center">
                                <mat-icon class="icon-compact"
                                  >settings</mat-icon
                                >
                                <small class="ms-2">{{
                                  "Collaborators.BUTTONS.SETTINGS" | translate
                                }}</small>
                                <mat-icon class="dropdown-chevron"
                                  >arrow_drop_down</mat-icon
                                >
                              </div>
                            </button>
                            <!-- Settings Menu -->
                            <mat-menu #settingsMenu="matMenu">
                              <!-- API Rules Menu Item -->
                              <button
                                mat-menu-item
                                [disabled]="e.status !== 'Accept'"
                                color="primary"
                                (click)="gotourules(e.id)"
                              >
                                <mat-icon
                                  color="primary"
                                  class="icon-compact icon-center icon-clean me-1"
                                  >description</mat-icon
                                >
                                <span>{{
                                  "Collaborators.BUTTONS.API_RULES" | translate
                                }}</span>
                              </button>

                              <!-- Copy URL Menu Item -->
                              <button
                                mat-menu-item
                                [disabled]="e.status !== 'Accept'"
                                color="primary"
                                (click)="copyAppURL(e, $event, i)"
                              >
                                <span *ngIf="!copied || activeIndex != i">
                                  <mat-icon
                                    color="primary"
                                    class="icon-compact icon-center icon-clean me-1"
                                    >content_copy</mat-icon
                                  >
                                  <span>{{
                                    "Collaborators.BUTTONS.COPY_URL" | translate
                                  }}</span>
                                </span>
                                <span *ngIf="copied && activeIndex === i">
                                  <mat-icon
                                    color="primary"
                                    class="icon-compact icon-center icon-clean me-1"
                                    >check</mat-icon
                                  >
                                  <span>{{
                                    "Collaborators.BUTTONS.COPIED" | translate
                                  }}</span>
                                </span>
                              </button>
                            </mat-menu>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <app-list-header [$parent]="getSelf()"></app-list-header>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- App Role Modal -->
<div class="modal fade" id="appRoleModal" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-scrollable">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">
          {{ "APPLICATIONS.APPLICATION_ROLE" | translate }}
        </h5>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          [title]="'COMMON.CLOSE' | translate"
        ></button>
      </div>
      <div class="modal-body">
        <app-add-app-role
          [curApp]="selectApp"
          *ngIf="selectApp && editor == 'app-role'"
        ></app-add-app-role>
      </div>
      <div class="modal-footer">
        <button
          mat-stroked-button
          color="warn"
          class="me-3"
          data-bs-dismiss="modal"
          [title]="'COMMON.CLOSE' | translate"
        >
          <mat-icon>close</mat-icon> {{ "COMMON.CLOSE" | translate }}
        </button>
      </div>
    </div>
  </div>
</div>

<!-- App Role Usecase Modal -->
<div
  class="modal fade"
  id="appRoleUsecaseModal"
  tabindex="-1"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-scrollable modal-xl">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">
          {{ "APPLICATIONS.ROLE_ACCESS" | translate }}
        </h5>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          [attr.aria-label]="'COMMON.CLOSE' | translate"
          [title]="'COMMON.CLOSE' | translate"
        ></button>
      </div>
      <div class="modal-body">
        <app-add-app-role-access
          [curApp]="selectApp"
          *ngIf="selectApp && editor == 'app-role-usecase'"
        ></app-add-app-role-access>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-outline-secondary btn-sm ml-2"
          data-bs-dismiss="modal"
          [title]="'COMMON.CLOSE' | translate"
        >
          <i class="fa fa-window-close"></i> {{ "COMMON.CLOSE" | translate }}
        </button>
      </div>
    </div>
  </div>
</div>

<!-- App User Modal -->
<div
  class="modal fade"
  id="appUserModal"
  tabindex="-1"
  aria-hidden="true"
  data-bs-backdrop="static"
  data-bs-keyboard="false"
  aria-labelledby="appUserstaticBackdropLabel"
>
  <div class="modal-dialog modal-dialog-scrollable modal-xl">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">
          {{ "APPLICATIONS.APPLICATION_MEMBERS" | translate }}
        </h5>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          [attr.aria-label]="'COMMON.CLOSE' | translate"
          [title]="'COMMON.CLOSE' | translate"
        ></button>
      </div>
      <div class="modal-body">
        <app-application-users
          [curApp]="selectApp"
          *ngIf="selectApp && editor == 'app-user'"
        ></app-application-users>
      </div>
      <div class="modal-footer border-0">
        <button
          mat-stroked-button
          color="warn"
          data-bs-dismiss="modal"
          [title]="'COMMON.CLOSE' | translate"
        >
          <mat-icon>close</mat-icon> {{ "COMMON.CLOSE" | translate }}
        </button>
      </div>
    </div>
  </div>
</div>